/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_PreviewInputs */

const vi_einvoice_preview = /** @type {(inputs: Einvoice_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem nháp`)
};

/**

* @param {Einvoice_PreviewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_preview = /** @type {((inputs?: Einvoice_PreviewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_PreviewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_preview(inputs)
});